module.exports = __webpack_public_path__ + "static/media/install-extension.81a9c577.png";